import Axios from '@/plugins/axios.js';
import { agentHubUrl } from '@/utils/config';

const prefix = `${agentHubUrl}/agent-hub-api`;

function post(path, data) {
  return Axios({
    url: `${prefix}${path}`,
    method: 'POST',
    data
  });
}

function get(path, params) {
  return Axios({
    url: `${prefix}${path}`,
    method: 'GET',
    params
  });
}

export function parsePartsFromImages(data) {
  return post('/api/product-case/ai/parse-parts-from-images', data);
}

export function parsePartsFromImagesProgressive(data) {
  return post('/api/product-case/ai/parse-parts-from-images-progressive', data);
}

export function getParseTask(taskId) {
  return get(`/api/product-case/ai/parse-task/${taskId}`);
}

export function refinePart(data) {
  return post('/api/product-case/ai/refine-part', data);
}

export function generateInternationalDraft(data) {
  return post('/api/product-case/ai/generate-intl-draft', data);
}

export function generateInternationalDraftProgressive(data) {
  return post('/api/product-case/ai/generate-intl-draft-progressive', data);
}
